var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 74,
    viewBox: "0 0 92 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.716 48.5627L59.3885 40.0156C66.4525 33.0542 66.4525 21.7507 59.3885 14.7893C52.3245 7.82691 40.855 7.82691 33.791 14.7893L5.29802 42.8692C-1.76601 49.8306 -1.76601 61.1341 5.29802 68.0955C12.362 75.0569 23.8325 75.0569 30.8965 68.0955C32.9141 66.1068 32.9141 62.8777 30.8965 60.889C28.8779 58.9003 25.6012 58.9003 23.5837 60.889C20.5548 63.874 15.6387 63.874 12.6099 60.889C9.58202 57.905 9.58202 53.0588 12.6099 50.0748L41.1029 21.9958C44.1317 19.0108 49.0488 19.0108 52.0767 21.9958C55.1045 24.9798 55.1045 29.8251 52.0767 32.8091L43.4041 41.3561C41.3856 43.3448 41.3856 46.574 43.4041 48.5627C45.4217 50.5513 48.6984 50.5513 50.716 48.5627Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1667 26.9091L32.4849 33.494C25.421 40.4554 25.421 51.7591 32.4849 58.7206C39.5489 65.6821 51.0191 65.6821 58.0831 58.7206L86.5756 30.6403C93.6395 23.6789 93.6395 12.3752 86.5756 5.41373C79.5117 -1.54774 68.0414 -1.54774 60.9785 5.41373C58.96 7.40244 58.96 10.6316 60.9785 12.6204C62.9961 14.6091 66.2727 14.6091 68.2903 12.6204C71.3181 9.63631 76.2351 9.63631 79.2639 12.6204C82.2917 15.6044 82.2917 20.4497 79.2639 23.4347L50.7703 51.5149C47.7425 54.499 42.8255 54.499 39.7977 51.5149C36.7699 48.5299 36.7699 43.6846 39.7977 40.6996L46.4794 34.1157C48.497 32.127 48.497 28.8978 46.4794 26.9091C44.4609 24.9204 41.1842 24.9204 39.1667 26.9091Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkImage);
export default __webpack_public_path__ + "static/media/link-image.74e79984dd754de9423bd8ae8f6b818d.svg";
export { ForwardRef as ReactComponent };